import type { BaseProvider } from '@k-msg/core';

export class ProviderManager {
  private providers: Map<string, BaseProvider> = new Map();
  private defaultProvider?: string;

  registerProvider(provider: BaseProvider): void {
    this.providers.set(provider.id, provider);

    // 첫 번째 프로바이더를 기본으로 설정
    if (!this.defaultProvider) {
      this.defaultProvider = provider.id;
    }
  }

  unregisterProvider(providerId: string): void {
    this.providers.delete(providerId);

    if (this.defaultProvider === providerId) {
      const remaining = Array.from(this.providers.keys());
      this.defaultProvider = remaining.length > 0 ? remaining[0] : undefined;
    }
  }

  getProvider(providerId?: string): BaseProvider | null {
    const id = providerId || this.defaultProvider;
    return id ? this.providers.get(id) || null : null;
  }

  listProviders(): BaseProvider[] {
    return Array.from(this.providers.values());
  }

  setDefaultProvider(providerId: string): void {
    if (!this.providers.has(providerId)) {
      throw new Error(`Provider ${providerId} not found`);
    }
    this.defaultProvider = providerId;
  }

  async healthCheckAll(): Promise<Record<string, boolean>> {
    const results: Record<string, boolean> = {};

    for (const [id, provider] of this.providers.entries()) {
      try {
        const health = await provider.healthCheck();
        results[id] = health.healthy;
      } catch (error) {
        results[id] = false;
      }
    }

    return results;
  }

  getProvidersForChannel(channel: string): BaseProvider[] {
    return Array.from(this.providers.values()).filter(provider => {
      const providerWithChannels = provider as BaseProvider & { supportedChannels?: string[] };
      return providerWithChannels.supportedChannels?.includes(channel);
    });
  }
}